<template>
  <div class="profile-avatar">
    <template v-if="user && user.email">
      <img
          class="profile-avatar__image"
          :src="user.photoURL"
          :alt="user.displayName"
           v-if="user && user.photoURL"
      >
      <i
          class="fa fa-user profile-avatar__icon"
          :src="user.photoURL"
          :alt="user.displayName"
           v-else
      />
      <h1 class="profile-avatar__name">{{user.displayName}}</h1>
      <h2 class="profile-avatar__email">{{user.email}}</h2>
    </template>
    <template v-else>
      <AppSection title="IDENTIFICATE CON TUS REDES" bgColor="white">
        <LoginSocial />
      </AppSection>
    </template>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import LoginSocial from './LoginSocial'

export default {
  components: { LoginSocial },
  computed: mapState({
    user: state => state.profile && state.profile.user
  })
}
</script>
<style lang="scss">
.profile-avatar {
  background-color: white;
  padding: 0.8rem 0.4rem 0.6rem 0.4rem;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;

  &__icon {
    border: 0.1em solid #999999;
    color: #999999;
    border-radius: 50%;
    font-size: 2rem;
    height: 60px;
    width: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 0.42rem;
  }

  &__image {
    border-radius: 50%;
    margin-bottom: 1rem;
    height: 60px;
  }

  &__name {
    font-size: 1.2rem;
    font-weight: bold;

    &__small {
      font-size: 0.82rem;
      text-transform: uppercase;
    }
  }

  &__email {
    font-size: 0.8em;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/User/UserAvatar.vue